import ApplicationController from './application_controller'
import Fetchers from 'core/fetchers';

export default class PresetFormController extends ApplicationController {
  static targets = ['productGroupContainer', 'productGroupButton', 'previewContainer',
    'markupInput', 'presetRadio', 'form', 'toggleRow', 'previewToggleButton']

  static outlets = ['containers--dialog-container']

  static values = {
    initialProductGroupId: String,
    previewPath: String,
  }

  initialize() {
    this.visibleTab = null;
    this.selectedPresetId = null;
  }

  connect() {
    this.initVisibleTab();
    this.updateSelectedPreset();
    this.updateTableVisibility();
    this.disableIrrelevantInputs();
    this.loadPreview();
  }

  changeTab(event) {
    this.setVisibleTab(event.params.id);
    this.updateSelectedPreset();
    this.updateTableVisibility();
    this.disableIrrelevantInputs();
    this.loadPreview();
  }

  updateForm() {
    this.updateSelectedPreset();
    this.validateMarkupValues();
    this.disableIrrelevantInputs();
    this.loadPreview();
  }


  selectedPreset() {
    let id;
    this.presetRadioTargets.forEach((radio) => {
      if (radio.checked === true) {
        id = radio.value;
      }
    });
    return id;
  }

  setVisibleTab(id) {
    if (id.length === 0) { return; }

    this.visibleTab = String(id);
  }

  updateTableVisibility() {
    this.productGroupContainerTargets.forEach((container) => {
      if (container.dataset.id === this.visibleTab) {
        container.classList.remove('hide')
      } else {
        container.classList.add('hide')
      }
    });
  }

  disableIrrelevantInputs() {
    this.markupInputTargets.forEach((input) => {
      if (input.dataset.productGroupTypeId === this.visibleTab && this.selectedPresetId === '') {
        input.disabled = false;
      } else {
        input.disabled = true;
      }
    });
  }

  updateSelectedPreset() {
    this.selectedPresetId = this.selectedPreset()
  }

  previewToggle() {
    const show = this.previewToggleButtonTarget.checked
    this.toggleRowTargets.forEach((target) => {
      if (show) {
        target.classList.remove('hide')
      } else {
        target.classList.add('hide')
      }
    });
  }

  loadPreview() {
    let formData = new FormData(this.formTarget);
    Fetchers.fetchGeneric(
      this.previewPathValue, 'POST', formData,
    )
      .then((response) => response.json())
      .then((data) => {
        this.previewContainerTarget.innerHTML = data.html
        this.previewToggle()
      })
  }

  serializedFormData() {
    let formData = new FormData(this.formTarget);

    const data = Array
      .from(formData.entries())
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {});

    return data;
  }

  initVisibleTab() {
    if (this.hasInitialProductGroupIdValue) {
      this.setVisibleTab(this.initialProductGroupIdValue);
    }
  }

  openConfirmationModal() {
    this.containersDialogContainerOutlet.open();
  }

  closeConfirmationModal() {
    this.containersDialogContainerOutlet.close();
  }

  validateMarkupValues() {
    const value = parseFloat(event.target.value);
    event.target.value = isNaN(value) ? '' : value.toFixed(2);
    
    const visibleContainer = this.productGroupContainerTargets.find(container => !container.classList.contains('hide'));
    if (!visibleContainer) return;

    const defaultInputs = visibleContainer.querySelectorAll('input[id^="preset_markups_"][id$="_markup"]:not([type="hidden"])');

    let allValid = true;

    defaultInputs.forEach((defaultInput) => {
      const productGroupId = this.extractProductGroupId(defaultInput.id);
      const saleInput = visibleContainer.querySelector(`#sale_preset_markups_${productGroupId}_markup`);
      if (!saleInput) return;

      const defaultValue = parseFloat(defaultInput.value);
      const valid = this.validPresetInputValues(defaultValue, saleInput)
      this.toggleErrorClassesForInput(defaultInput, defaultValue, saleInput, valid)
      if (!valid) allValid = false;
    });

    this.toggleSubmitButton(allValid);
  }

  extractProductGroupId(id) {
    const parts = id.split('_'); // "preset_markups_118_markup"
    return parts[2];             // returns "118"
  }

  validPresetInputValues(defaultValue, saleInput) {
    const saleValue = parseFloat(saleInput.value);
    const minValue = parseFloat(saleInput.min);

    return !isNaN(defaultValue) &&
      !isNaN(saleValue) &&
      defaultValue >= minValue &&
      saleValue >= minValue &&
      defaultValue > saleValue;
  }

  toggleErrorClassesForInput(defaultInput, defaultValue, saleInput, valid) {
    if (defaultValue <= parseFloat(defaultInput.min)) {
      defaultInput.parentElement.classList.toggle('tp-input-field--text-error', true);
    } else {
      defaultInput.parentElement.classList.toggle('tp-input-field--text-error', false);
    }
    saleInput.parentElement.classList.toggle('tp-input-field--text-error', !valid);
  }

  toggleSubmitButton(enabled) {
    const submit = document.querySelector('.jsPricingSubmit');
    if (submit) submit.disabled = !enabled;
  }
}
